import { useEffect, useRef } from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { FileText, Folder } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import FileOptions from "../Reusable/FileOptions";
import Options from "../Reusable/OptionsPopOver";

const TableView = (props: any) => {
  const {
    setSelected,
    setOpenRenameFolderPopup,
    handleDeleteFolder,
    isDeleting,
    folderList,
    fileList,
    handleDeleteFile,
    setOpenRenameFilePopup,
    isdeleteLoading,
  } = props;

  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const limit = parseInt(searchParams.get("limit") || "10", 10);
  const observerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setSearchParams({ limit: "10" });
  }, []);
  const folders = folderList?.map((folder: any) => ({
    ...folder,
    _type: "folder",
  }));
  const files = fileList?.map((file: any) => ({ ...file, _type: "file" }));
  const combined = [...folders, ...files];
  const visible = combined.slice(0, limit);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && combined.length > limit) {
          const newLimit = limit + 10;
          setSearchParams({ limit: newLimit.toString() });
        }
      },
      { threshold: 1 }
    );

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }

    return () => {
      if (observerRef.current) {
        observer.unobserve(observerRef.current);
      }
    };
  }, [limit, combined.length]);

  return (
    <div className={tw`mt-4`}>
      <table className={tw`w-full table-auto text-left`}>
        <thead className={tw`border-b`}>
          <tr>
            <th className={tw`px-4 py-2`}>Name</th>
            <th className={tw`px-4 py-2`}>Upload Date</th>
            <th className={tw`px-4 py-2`}>Created By</th>
            <th className={tw`px-4 py-2`}>Location</th>
            <th className={tw`px-4 py-2`}></th>
          </tr>
        </thead>
        <tbody>
          {visible.map((item: any) => {
            const isFolder = item._type === "folder";
            const title = item.title;
            const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(title);

            return (
              <tr
                key={item.id}
                className={tw`border-b hover:bg-gray-100 cursor-pointer`}
                onClick={() => {
                  if (isFolder) navigate(`folder/${item.id}`);
                }}
              >
                <td className={tw`px-4 py-2 flex items-center gap-2`}>
                  {isFolder ? (
                    <Folder />
                  ) : isImage ? (
                    <img
                      src={item.file}
                      alt={title}
                      className={tw`w-5 h-5 object-cover rounded-sm`}
                    />
                  ) : (
                    <FileText className={tw`text-blue-400 w-5 h-5`} />
                  )}
                  <span>{title}</span>
                </td>
                <td className={tw`px-4 py-2`}>{item.uploadedAt || "—"}</td>
                <td className={tw`px-4 py-2`}>–</td>
                <td className={tw`px-4 py-2`}>–</td>
                <td className={tw`px-4 py-2`}>
                  {isFolder ? (
                    <Options
                      setSelected={setSelected}
                      folder={item}
                      setOpenRenameFolderPopup={setOpenRenameFolderPopup}
                      handleDelete={handleDeleteFolder}
                      isdeleteLoading={isDeleting}
                    />
                  ) : (
                    <FileOptions
                      setSelected={setSelected}
                      file={item}
                      setOpenRenameFolderPopup={setOpenRenameFilePopup}
                      handleDelete={handleDeleteFile}
                      isdeleteLoading={isdeleteLoading}
                    />
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div ref={observerRef} className={tw`h-10`} />
    </div>
  );
};

export default TableView;

